import React from 'react';
import { motion } from 'framer-motion';
import { Check, Mail, MapPin, Music2, Instagram } from 'lucide-react';
export function FinalCTA() {
  return <section id="contacto" className="py-20 md:py-32 bg-negro px-5 md:px-8 relative overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-noise" data-id="element-71"></div>

      <div className="max-w-[1180px] mx-auto relative z-10" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-73">
          {/* Left: Text Content */}
          <div data-id="element-74">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-ambar font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-75">
              Empezamos cuando quieras
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white mb-8 leading-tight" data-id="element-76">
              Tu negocio se merece una presencia que lo muestre como lo que es.
            </motion.h2>

            <div className="space-y-6 text-white/70 font-nunito text-lg mb-10" data-id="element-77">
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} data-id="element-78">
                No hace falta que todo esté perfecto.
                <br data-id="element-79" />
                No hace falta que sepas de marketing.
                <br data-id="element-80" />
                Solo necesitás querer que tu marca se vea como lo que es.
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} data-id="element-81">
                Nos sentamos con vos, miramos tu situación actual y te decimos
                con honestidad qué necesitás y qué no.
              </motion.p>
            </div>

            <ul className="space-y-4" data-id="element-82">
              {['Sin compromiso ni contratos forzosos', 'Respondemos en menos de 24hs', 'Hablás directo con nosotros'].map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4 + 0.1 * index
            }} className="flex items-center gap-3" data-id="element-83">
                  <Check className="text-ambar" size={20} strokeWidth={3} data-id="element-84" />
                  <span className="text-white font-nunito" data-id="element-85">{item}</span>
                </motion.li>)}
            </ul>
          </div>

          {/* Right: Contact Box */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-arena/[0.06] border border-arena/[0.12] rounded-[16px] p-8 md:p-10" data-id="element-86">
            <h3 className="text-2xl md:text-3xl font-playfair font-bold text-white mb-2" data-id="element-87">
              Escribinos por WhatsApp
            </h3>
            <p className="text-arena/60 font-nunito text-sm mb-8" data-id="element-88">
              Es el primer paso. Sin costo, sin presión, sin tecnicismos.
            </p>

            <a href="https://wa.link/9j4vxx" target="_blank" rel="noopener noreferrer" className="w-full bg-[#25D366] text-white font-nunito font-bold rounded-[12px] py-4 px-6 flex items-center justify-center gap-2 hover:bg-[#20bd5a] transition-colors duration-250 mb-8" data-id="element-89">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" data-id="element-90">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-91" />
              </svg>
              Abrir WhatsApp &rarr;
            </a>

            <div className="flex items-center gap-4 mb-8" data-id="element-92">
              <div className="h-[1px] flex-1 bg-arena/10" data-id="element-93"></div>
              <span className="text-arena/40 font-nunito text-sm" data-id="element-94">
                — o también —
              </span>
              <div className="h-[1px] flex-1 bg-arena/10" data-id="element-95"></div>
            </div>

            <div className="space-y-4 mb-8" data-id="element-96">
              <a href="mailto:quebradadigital.tilcara@gmail.com" className="flex items-center gap-3 text-arena/55 font-nunito text-sm hover:text-ambar transition-colors duration-250" data-id="element-97">
                <Mail size={18} data-id="element-98" />
                <span data-id="element-99">quebradadigital.tilcara@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-arena/55 font-nunito text-sm" data-id="element-100">
                <MapPin size={18} data-id="element-101" />
                <span data-id="element-102">Tilcara, Jujuy</span>
              </div>
              <a href="https://www.instagram.com/quebradadigital.tilcara" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-arena/55 font-nunito text-sm hover:text-ambar transition-colors duration-250" data-id="element-103">
                <Instagram size={18} data-id="element-104" />
                <span data-id="element-105">@quebradadigital.tilcara en Instagram</span>
              </a>
              <a href="https://www.tiktok.com/@quebradadigital22" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-arena/55 font-nunito text-sm hover:text-ambar transition-colors duration-250" data-id="element-106">
                <Music2 size={18} data-id="element-107" />
                <span data-id="element-108">@quebradadigital22 en TikTok</span>
              </a>
            </div>

            <p className="text-arena/35 font-nunito text-xs leading-relaxed" data-id="element-109">
              Respondemos de lunes a sábado.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}